<template>
  <div class="purchase-detail-content">
    <div v-if="basicProduct(pack).length > 0 || optionProduct(pack).length > 0 " class="tbl01 purchase-detail-table">
      <table class="tbl">
        <colgroup>
          <col style="width:80%;">
          <col style="width:20%;">
        </colgroup>
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th class="ta-center">解約ライセンス数</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, index) in basicProduct(pack)" :key="'basic_prod_' + index">
            <th>{{product.name}}</th>
              <td v-if="product.license_number === 0 || isBasicCanceled(pack)" class="ta-center">解約</td>
              <td v-else class="ta-center">{{product.license_number}}</td>
          </tr>
          <tr v-for="(product, index) in optionProduct(pack)" :key="'option_prod_' + index">
            <th class="pl40">{{product.name}}</th>
            <td v-if="product.license_number === 0 || isBasicCanceled(pack)" class="ta-center">解約</td>
            <td v-else class="ta-center">{{product.license_number}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import { CancelTable } from '@/logic/contract/CancelTable'

export default defineComponent({
  name: 'CancelTable',
  props: {
    pack: {
      type: Object,
      default: null
    }
  },
  setup (props, context) {
    return { ...CancelTable(props, context) }
  }
})
</script>
